import Axios from 'axios'
import { Dispatch } from 'redux'
import { clearAlert, createAlert, handleError } from 'util/modules/Alert/redux/actions'
import { ActionResponse } from 'util/types/index'
import { PartnerStaff, PartnerStaffData, PartnerStaffTypes } from './types'

export function createPartnerStaff (partnerId: number|string, data: PartnerStaffData) {
  return async (dispatch: Dispatch): Promise<ActionResponse<PartnerStaff>> => {
    return Axios
      .post(`/partner/${partnerId}/staff`, data)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: PartnerStaffTypes.PARTNER_STAFF_CREATE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao cadastrar o funcionário')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function deletePartnerStaff (partnerId: number|string, id: number|string) {
  return async (dispatch: Dispatch): Promise<ActionResponse<number>> => {
    return Axios
      .delete(`/partner/${partnerId}/staff/${id}`)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: PartnerStaffTypes.PARTNER_STAFF_DELETE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao remover o funcionário')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function getPartnerStaffs (partnerId: number|string) {
  return async (dispatch: Dispatch): Promise<ActionResponse<PartnerStaff[]>> => {
    return Axios
      .get(`/partner/${partnerId}/staff`)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res.data) {
          dispatch({ type: PartnerStaffTypes.PARTNER_STAFF_GET_LIST, payload: res.data })
        }
        return res
      })
  }
}
